"use strict";
//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var theme_1 = require("./theme");
exports.theme = theme_1.default;
